<template>
  <div>
    <div class="loading" v-if="loading">
      <div class="loader">
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
      </div>
    </div>
    <div v-if="fetch">
      <b-modal
        v-model="modalShow"
        centered
        ok-only
        centered
        class="text-center text-info"
      >
        You order has been sent
      </b-modal>
      <b-modal
        v-model="modalShow1"
        centered
        ok-only
        centered
        class="text-center text-info"
      >
        Please wait. Your order is being sent.
      </b-modal>
      <!-- breadcrumb -->
      <!-- <div class="container">
		<div class="bread-crumb flex-w p-l-25 p-r-15 p-t-30 p-lr-0-lg">
			<a href="index.html" class="stext-109 cl8 hov-cl1 trans-04">
				Home
				<i class="fa fa-angle-right m-l-9 m-r-10" aria-hidden="true"></i>
			</a>

			<span class="stext-109 cl4">
				Shoping Cart
			</span>
		</div>
	</div> -->

      <!-- Shoping Cart -->
      <form class="p-t-40 p-b-50 mobi-p-t-30">
        <div class="container">
          <div class="row">
            <div class="col-sm-10 col-lg-10 col-xl-7 m-lr-auto m-b-50">
              <div class="m-l-25 m-r--38 m-lr-0-xl">
                <div class="wrap-table-shopping-cart">
                  <table class="table-shopping-cart">
                    <tr class="table_head">
                      <th class="column-1">Product</th>
                      <th class="column-2"></th>
                      <th class="column-3">Price</th>
                      <th class="column-4">Quantity</th>
                      <th class="column-5">Subtotal</th>
                    </tr>

                    <tr
                      class="table_row"
                      v-for="(item, i) in cartItems"
                      v-bind:key="item.id"
                    >
                      <td class="column-1">
                        <div class="how-itemcart1">
                          <img v-bind:src="item.image" alt="IMG" />
                        </div>
                      </td>
                      <td class="column-2">
                        <span
                          class="mr-3 text-danger"
                          @click="deleteCartItem(i)"
                          style="
                            font-weight: bold;
                            font-size: 20px;
                            cursor: pointer;
                          "
                          >X</span
                        >{{ item.name }}
                      </td>
                      <td class="column-3">RS {{ item.price }}</td>
                      <td class="column-4">
                        <div class="wrap-num-product flex-w m-l-auto m-r-0">
                          <div
                            class="
                              btn-num-product-down
                              cl8
                              hov-btn3
                              trans-04
                              flex-c-m
                            "
                            @click="decQuantity(i)"
                          >
                            <i class="fs-16 fa fa-minus"></i>
                          </div>

                          <input
                            class="mtext-104 cl3 txt-center num-product"
                            type="number"
                            name="num-product2"
                            :value="item.quantity"
                          />

                          <div
                            class="
                              btn-num-product-up
                              cl8
                              hov-btn3
                              trans-04
                              flex-c-m
                            "
                            @click="incQuantity(i)"
                          >
                            <i class="fs-16 fa fa-plus"></i>
                          </div>
                        </div>
                      </td>
                      <td class="column-5">
                        RS{{ item.quantity * item.price }}
                      </td>
                    </tr>
                  </table>
                </div>

                <div
                  class="
                    flex-w flex-sb-m
                    bor15
                    p-t-18 p-b-15 p-lr-40 p-lr-15-sm
                  "
                >
                  <div class="size-208" :style="{ display: display }">
                    <span class="stext-110 cl2"> Total: </span>
                  </div>

                  <div class="size-209" :style="{ display: display }">
                    <span class="mtext-110 cl2">
                      RS {{ Math.round((Total + 0.00001) * 100) / 100 }}
                    </span>
                  </div>

                  <!-- <div class="flex-w flex-m m-r-20 m-tb-5">
								<input class="stext-104 cl2 plh4 size-117 bor13 p-lr-20 m-r-10 m-tb-5" type="text" name="coupon" placeholder="Coupon Code">
									
								<div class="flex-c-m stext-101 cl2 size-118 bg8 bor13 hov-btn3 p-lr-15 trans-04 pointer m-tb-5">
									Apply coupon
								</div>
							</div>

							<div class="flex-c-m stext-101 cl2 size-119 bg8 bor13 hov-btn3 p-lr-15 trans-04 pointer m-tb-10" @click="calcCartTotal()">
								Update Cart
							</div> -->
                </div>
              </div>
            </div>

            <div class="col-sm-10 col-lg-7 col-xl-5 m-lr-auto m-b-50">
              <div
                class="
                  bor10
                  p-lr-40 p-t-30 p-b-40
                  m-l-63 m-r-40 m-lr-0-xl
                  p-lr-15-sm
                  mobi-m-lr
                "
              >
                <h4 class="mtext-109 cl2 p-b-30">Your Details</h4>

                <div class="flex-w flex-t bor12 p-t-15 p-b-30">
                  <div class="size-209 p-r-18 p-r-0-sm w-full-ssm">
                    <div class="p-t-15">
                      <el-form :model="formdata" ref="formdata" size="medium">
                        <el-form-item
                          prop="name"
                          :rules="[
                            {
                              required: true,
                              message: 'Please input your name',
                              trigger: 'blur',
                            },
                          ]"
                        >
                          <el-input
                            placeholder="Name"
                            v-model="formdata.name"
                          ></el-input>
                        </el-form-item>

                        <el-form-item
                          prop="telephone"
                          :rules="[
                            {
                              required: true,
                              message: 'telephone no is required',
                            },
                            {
                              type: 'number',
                              message: 'telephone no must be a number',
                            },
                          ]"
                        >
                          <el-input
                            v-model.number="formdata.telephone"
                            placeholder="Telephone (without 0)"
                            auto-complete="off"
                          ></el-input>
                        </el-form-item>

                        <el-form-item
                          prop="address"
                          :rules="[
                            {
                              required: true,
                              message: 'Please input address',
                              trigger: 'blur',
                            },
                          ]"
                        >
                          <el-input
                            type="text"
                            placeholder="Address"
                            v-model="formdata.address"
                          ></el-input>
                        </el-form-item>

                        <div class="flex-w flex-t p-t-27 p-b-33">
                          <div class="size-208">
                            <span class="mtext-101 cl2"> Total: </span>
                          </div>

                          <div class="size-209 p-t-1">
                            <span class="mtext-110 cl2">
                              RS {{ Math.round((Total + 0.00001) * 100) / 100 }}
                            </span>
                          </div>
                        </div>

                        <el-form-item>
                          <div
                            class="
                              flex-c-m
                              stext-101
                              cl2
                              size-119
                              bg10
                              bor13
                              hov-btn3
                              p-lr-15
                              trans-04
                              pointer
                              m-tb-10
                            "
                            @click="sendOrder('formdata')"
                          >
                            Send Order
                          </div>
                        </el-form-item>
                      </el-form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import db from "../../config/FirebaseInit";
import firebase from "firebase/app";
import { bus } from "../../main";
export default {
  name: "cart",
  data() {
    return {
      loading: false,
      fetch: false,
      modalShow: false,
      modalShow1: false,
      cartItems: [],
      cartSubTotals: [],
      shops: [],
      orders: "",
      cartLength: 0,
      Total: 0,
      display: "none",
      formdata: {
        name: "",
        telephone: "",
        address: "",
      },
    };
  },
  computed: {},
  beforeCreate() {
    //console.log('firebase.auth().currentUser', firebase.auth().currentUser.displayName)
  },
  beforeRouteEnter(to, from, next) {
    // this.prvroute = from
    //console.log(from.fullPath)
    if (firebase.auth().currentUser) {
      if (firebase.auth().currentUser.displayName != "shop owner") {
        next();
      } else if (firebase.auth().currentUser.displayName == "shop owner") {
        next();
        // 	    setTimeout(() => {
        //     next(vm => {
        //      return vm.$router.push(from.fullPath)
        //     })
        //   },100)
      }
    } else if (!firebase.auth().currentUser) {
      setTimeout(() => {
        next((vm) => {
          return vm.$router.push("/signin");
        });
      }, 100);
    }
  },
  created() {
    this.backToTop();
    this.loading = true;
    this.fetch = false;
    this.$store.state.secondaryDatabase
      .collection("carts")
      .where("uid", "==", firebase.auth().currentUser.uid)
      .where("shopid", "==", this.$route.params.storename)
      .get()
      .then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          const data = {
            id: doc.id,
            name: doc.data().prdname,
            price: doc.data().price,
            prdid: doc.data().prdid,
            image: doc.data().img,
            quantity: doc.data().quantity,
            subTotal: doc.data().total,
            barcode: doc.data().barcode
          };
          this.cartItems.push(data);
          this.cartLength = this.cartItems.length;
          this.cartSubTotals = this.cartItems.map((citem) => citem.subTotal);
          //console.log(this.cartItems)
          //console.log('subtotal array',this.cartSubTotals)
        });
      })
      .then(() => {
        this.loading = false;
        this.fetch = true;
        this.cartTotal(this.cartSubTotals);
        this.display = "block";
        //console.log('called')
      });
    this.$store.state.secondaryDatabase
      .collection("shops")
      .where("owner", "==", this.$route.params.storename)
      .get()
      .then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          const data = {
            id: doc.id,
            orders: doc.data().orders,
          };
          this.shops.push(data);
          this.orders = this.shops[0].orders;
        });
      });
  },

  methods: {
    sendOrder(fdata) {
      //console.log('cartItems are:', Array.isArray(this.cartItems))
      this.$refs[fdata].validate((valid) => {
        if (valid) {
          this.modalShow1 = true;
          var products = [];
          this.cartItems.forEach((item) => {
            if (item.quantity > 0) {
              products.push(item);
            }
          });
          //console.log(products)
          if (products.length > 0) {
            const orderNo = Math.floor(Math.random() * 100000001).toString()
            
            db.collection("orders")
              .add({
                uemail: firebase.auth().currentUser.email,
                uid: firebase.auth().currentUser.uid,
                uname: this.formdata.name,
                telno: this.formdata.telephone,
                address: this.formdata.address,
                shopid: this.$route.params.storename,
                products: products,
                total: this.Total,
                status: "Pending",
                date: firebase.firestore.Timestamp.now(),
                orderNo,
                //   price: this.filteredProducts[n].price,
                //   total: this.filteredProducts[n].price,
                // imageUrl: this.item.image
              })
              .then((doc) => {
                //console.log(doc.id)
                if(!this.$store.state.noDB) {
                  this.$store.state.secondaryDatabase
                    .collection("orders")
                    .add({
                      uemail: firebase.auth().currentUser.email,
                      uid: firebase.auth().currentUser.uid,
                      uname: this.formdata.name,
                      telno: this.formdata.telephone,
                      address: this.formdata.address,
                      shopid: this.$route.params.storename,
                      products: products,
                      total: this.Total,
                      status: "Pending",
                      refid: doc.id,
                      date: firebase.firestore.Timestamp.now(),
                      orderNo
                      //   price: this.filteredProducts[n].price,
                      //   total: this.filteredProducts[n].price,
                      // imageUrl: this.item.image
                    })
                    .then((doc2) => {})
                    .catch((error) => alert(error));
                  }
                this.orders += 1;
                this.$store.state.secondaryDatabase
                  .collection("shops")
                  .doc(this.shops[0].id)
                  .update({
                    orders: this.orders,
                  })
                  .then((doc) => {
                    this.modalShow = true;
                    //console.log('doc is', doc)
                  })
                  .catch((error) => alert(error));

                this.$store.state.secondaryDatabase
                  .collection("carts")
                  .where("uid", "==", firebase.auth().currentUser.uid)
                  .where("shopid", "==", this.$route.params.storename)
                  .get()
                  .then((querySnapshot) => {
                    querySnapshot.forEach((doc) => {
                      //console.log('doc id',doc.id)
                      this.$store.state.secondaryDatabase
                        .collection("carts")
                        .doc(doc.id)
                        .delete()
                        .then(() => {
                          //console.log('cart item deleted')
                          this.$store.state.cartItems[
                            this.$route.params.storename
                          ] = 0;
                        })
                        .catch((error) => alert(error));
                    });
                    //  setTimeout(() => {
                    // 	this.$router.go(this.$route.fullPath)
                    //  }, 2000)
                    this.cartItems = [];
                    this.Total = 0;
                    this.cartLength = 0;
                    this.formdata.name = "";
                    this.formdata.telephone = "";
                    this.formdata.address = "";
                    var cartItems = 0;
                    bus.$emit("cartChanged", cartItems);
                    this.$store.state.cartItems[
                      this.$route.params.storename
                    ] = 0;
                  })

                  .catch((error) => alert(error));
              })
              .catch((error) => alert(error));
          } else {
            alert("Please Add Items to the Cart !!!");
          }
        } else {
          alert("Please Enter Your Details !!!");
          return false;
        }
      });
    },
    backToTop: function () {
      $("html,body").stop().animate(
        {
          scrollTop: 0,
        },
        "fast",
        "swing"
      );
    },
    incQuantity(n) {
      this.cartItems[n].quantity++;
      this.cartItems[n].subTotal =
        this.cartItems[n].quantity * this.cartItems[n].price;
      this.Total += this.cartItems[n].price;

      this.$store.state.secondaryDatabase
        .collection("carts")
        .doc(this.cartItems[n].id)
        .update({
          quantity: this.cartItems[n].quantity,
          total: this.cartItems[n].subTotal,
        });
    },
    decQuantity(n) {
      if (this.cartItems[n].quantity > 1) {
        this.cartItems[n].quantity--;

        this.cartItems[n].subTotal =
          this.cartItems[n].quantity * this.cartItems[n].price;
        this.Total -= this.cartItems[n].price;

        this.$store.state.secondaryDatabase
          .collection("carts")
          .doc(this.cartItems[n].id)
          .update({
            quantity: this.cartItems[n].quantity,
            total: this.cartItems[n].subTotal,
          });
      }
    },
    cartTotal(total) {
      //console.log('cartTotal called')
      //   this.subTotals(this.cartItems)
      this.Total += total.reduce(add, 0);

      function add(a, b) {
        return a + b;
      }
      //console.log(this.Total, 'at func')
      return this.Total;
    },
    deleteCartItem(n) {
      var newCart = this.cartItems.filter((citem) => {
        return citem.id !== this.cartItems[n].id;
      });
      this.cartSubTotals = [];

      //console.log('newCart', newCart)
      //console.log('empty this.cartSubTotals', this.cartSubTotals)

      this.$store.state.secondaryDatabase
        .collection("carts")
        .doc(this.cartItems[n].id)
        .delete()
        .then(() => {
          //console.log('cart item deleted')

          this.cartItems = newCart;
          this.cartLength -= 1;
          var cartItems = this.cartLength;
          bus.$emit("cartChanged", cartItems);
          this.$store.state.cartItems[this.$route.params.storename] -= 1;

          //console.log('new this.cartItems', this.cartItems)
          this.Total = 0;
          this.cartSubTotals = this.cartItems.map((citem) => citem.subTotal);
          //console.log('new this.cartSubTotals', this.cartSubTotals)
          this.cartTotal(this.cartSubTotals);

          //return this.$router.go(this.$route.fullPath)
        })

        .catch((error) => {
          //console.log(error)
        });
    },
  },
};
</script>

<style scoped>
@import url("~@/assets/main/css/loading.css");
@media (max-width: 767px) {
  .mobi-p-t-30 {
    padding-top: 75px;
  }
  .mobi-m-lr {
    margin-left: 0px;
    margin-right: 0px;
  }
}
</style>






// WEBPACK FOOTER //
// src/components/store/Cart.vue